import template from './myLoansModal.html';
import controller from './myLoansModal.controller';
import './myLoansModal.scss';

let myLoansModalComponent = {
  restrict: 'E',
  bindings: {
    loan: '<',
    optionIsSelected: '<',
    onSave: '&',
    loanResponseId: '<',
    onCancelAmortization: '&',
    cancelAmortizationErrorMessage: '<',
    simulation: '<',
    closeModalCadastral: '&',
    showCadastralReference: '&',
    resetFormCadastral: '&',
    tempLoanObject: '<',
    isMobileApp: '<'
  },
  template,
  controller,
};

export default myLoansModalComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/modals/myLoansModal/myLoansModal.component.js